import {forwardRef} from 'react';
import ExpandingTextarea from 'react-expanding-textarea';
import styled from 'styled-components';

const StyledTextarea = styled(ExpandingTextarea)`
  border-radius: 8px;
  border: ${({theme}) => theme.input.default.border};
  background: ${({theme}) => theme.input.default.bg};
  color: ${({theme}) => theme.input.default.text};
  font-weight: 400;
  line-height: 1.5;
  padding: 8px 16px;
  resize: none;

  &:focus {
    outline: 0;
    border: ${({theme}) => theme.input.focus.border};
    background: ${({theme}) => theme.input.focus.bg};
    color: ${({theme}) => theme.input.focus.text};
  }
`;

const Textarea = forwardRef(({title, ...props}, ref) => (
  <StyledTextarea {...props} ref={ref} />
));

export default Textarea;
